// extracted by mini-css-extract-plugin
module.exports = {"errorService500":"styles_errorService500__3cpXf","iconSession":"styles_iconSession__1v_GK","titleMessage":"styles_titleMessage__3Erye","textMessage":"styles_textMessage__3H7oN"};